import { gql } from '@apollo/client';

export const DELETE_SCORING_CATEGORY = gql`
  mutation deleteScoringCategory($input: DeleteScoringCategoryInput) {
    deleteScoringCategory(input: $input) {
      commandId
    }
  }
`;
